"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _provider = require("../provider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Access a set of initialized Commerce API clients, which are initialized using the configurations passed to the CommerceApiProvider.
 *
 * @group Helpers
 *
 * @returns Commerce API clients
 */
const useCommerceApi = () => {
  return _react.default.useContext(_provider.CommerceApiContext);
};
var _default = exports.default = useCommerceApi;